import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Box, Button } from '@mui/material';

import { useAppContext } from '../context/AppContext';
const UserProfile = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { profile, getProfile } = useAppContext();

    const applications = [
        { name: 'LTV extension', balance: 100, code: "ltv-extension" },
        { name: 'LTV Reseal', balance: 200, code: "ltv-reseal" },
        { name: 'OneShot Signature', balance: 300, code: "oneshot-signature" },
        { name: 'OTP OneShot', balance: 150, code: "otp-oneshot" },
        { name: 'Signature', balance: 50, code: "signature" },
        { name: 'LTV Signature', balance: 350, code: "ltv-signature" },
        { name: 'Signcloud', balance: 75, code: "cryptoapi" },
        { name: 'TimeStamp', balance: 200, code: "timestamp" },
        { name: 'Verification', balance: 500, code: "validation" },
    ];

    useEffect(() => {
        getProfile();
    }
    , []);

    const handleLoad = (app) => {
        navigate(`/user/${id}/${app.application_id}/load`);
    }

    const handleTransfer = (app) => {
        navigate(`/user/${id}/${app.application_id}/transfer`);
    }

    const handleEdit = (app) => {
        navigate(`/user/${id}/applications/${app.application_id}`);
    };

    const codeToName = (code) => {
        const app = applications.find(app => app.code === code);
        return app ? app.name : code;
    }
    console.log('profile', profile);
    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={2} sx={{ mb: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            {profile ? (
                                <>
                                    <Typography variant="h6" gutterBottom>User Information</Typography>
                                    <Typography>Name: {profile.client_first_name}</Typography>
                                    <Typography>Email: {profile.email}</Typography>
                                </>
                            ) : (
                                <Typography variant="h6" gutterBottom>User Information</Typography>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            
        </Box>
    );
};

export default UserProfile;
